var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8721 1.9658C12.4655 0.559214 10.1849 0.559212 8.77834 1.9658L6.42386 4.32028C6.28166 4.46248 6.39599 4.68746 6.59691 4.67884L7.54754 4.63805C7.7193 4.63068 7.88205 4.55915 8.00362 4.43758L9.62686 2.81433C10.5648 1.87637 12.0856 1.87637 13.0235 2.81433C13.9615 3.7523 13.9615 5.27303 13.0235 6.211L10.6691 8.56547C9.73109 9.50343 8.21036 9.50343 7.27239 8.56547C7.22741 8.52048 7.18458 8.47416 7.14391 8.42662C6.98786 8.24422 6.76688 8.11813 6.52706 8.12842C6.0772 8.14772 5.78347 8.60639 6.04695 8.97152C6.15876 9.12647 6.2844 9.27453 6.42386 9.414C7.83046 10.8206 10.111 10.8206 11.5176 9.414L13.8721 7.05953C15.2786 5.65293 15.2786 3.3724 13.8721 1.9658Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96838 7.81452C9.44491 7.79829 9.74463 7.30266 9.43953 6.93625C9.3683 6.85071 9.29256 6.76766 9.21231 6.68741C7.78473 5.25982 5.47016 5.25982 4.04257 6.68741L1.76412 8.96586C0.336536 10.3934 0.336535 12.708 1.76412 14.1356C3.1917 15.5632 5.50627 15.5632 6.93386 14.1356L9.21231 11.8571C9.31048 11.759 9.2341 11.6002 9.09534 11.6049L7.98237 11.6428C7.81422 11.6485 7.65451 11.7179 7.53554 11.8369L6.08533 13.2871C5.12637 14.246 3.5716 14.246 2.61265 13.2871C1.65369 12.3281 1.65369 10.7733 2.61265 9.81439L4.8911 7.53594C5.85006 6.57698 7.40483 6.57698 8.36378 7.53594C8.37023 7.54239 8.37664 7.54886 8.383 7.55537C8.53865 7.71444 8.74595 7.82209 8.96838 7.81452Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.65449df02dd3ddc9743ff186aa194aa9.svg";
export { ForwardRef as ReactComponent };